import React from "react";
import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import moment from "moment";
import { Link } from "react-router-dom";
import DataLabel from "./DataLabel";
import { Product } from "../../../graphql/fragments/product";

interface CardProps {
  product: Product;
}

const Card: React.FC<CardProps> = (props) => {
  const { name, previewDescription, description, publishDate, createdAt, id } =
    props.product;

  const formatDate = (date: string) => moment(date).format("MM/DD/YYYY");

  return (
    <Box p={4} display={{ md: "flex" }} borderWidth={1} borderRadius={5}>
      <Stack width="100%">
        <Flex justifyContent="space-between" alignItems="center">
          <Link to={`/products/${id}/edit`}>
            <Text fontWeight="bold" fontSize="lg" color="teal.600">
              {name}
            </Text>
          </Link>
          <Stack>
            <DataLabel text="Published" data={formatDate(publishDate)} />
            <DataLabel text="Created" data={formatDate(createdAt)} />
          </Stack>
        </Flex>
        <Text my={2}>{previewDescription}</Text>
        <Text my={2} color="gray.500">
          {description}
        </Text>
      </Stack>
    </Box>
  );
};

export default Card;
